// src/features/simulators/online-checkin/types/index.ts

import {
  SectionCode,
  JourneyEventCode,
  KeyDeliveryMethod,
} from '@/features/simulators/shared/types/journey.types';

// Re-export shared types
export { SectionCode, JourneyEventCode, KeyDeliveryMethod };

// Online check-in specific constants
export const ONLINE_CHECKIN_SECTIONS = [
  SectionCode.S,
  SectionCode.I,
  SectionCode.F,
  SectionCode.U,
  SectionCode.P,
] as const;

export const ONLINE_CHECKIN_CHANNEL = 'Online';

export const ONLINE_CHECKIN_DEVICE_TYPE = 'Virtual';

/**
 * Link access method (how guest accessed pre-check-in)
 */
export enum LinkAccessMethod {
  EMAIL = 'Email',               // Link sent via email
  SMS = 'SMS',                   // Link sent via SMS
  DIRECT = 'Direct',             // Direct link access
}

/**
 * Configuration for online check-in simulator
 */
export interface OnlineCheckInConfig {
  hotelId: string;
  deviceId: string;
  count: number;
  delayBetweenSteps: number;
  delayBetweenSessions: number;
  keyDeliveryMethod: KeyDeliveryMethod;  // Changed from digitalKeyMethod
  linkAccessMethod: LinkAccessMethod;
  errorRate: number;
  abandonmentRate: number;
  digitalKeyRate: number;                // Percentage of sessions that receive digital key
  reservationNumber?: string;            // Optional manual reservation number
  autoGenerateReservation?: boolean;     // Auto-generate or manual entry
}

/**
 * Statistics for online check-in simulator
 */
export interface OnlineCheckInStats {
  totalSessions: number;
  successfulSessions: number;
  failedSessions: number;
  abandonedSessions: number;
  totalEvents: number;
  averageTime: number;
  
  // Payment
  paymentSuccesses: number;
  paymentErrors: number;
  
  // Digital keys
  digitalKeysDelivered: number;
  digitalKeyErrors: number;
  
  // Access method
  fromEmail: number;
  fromSMS: number;
  fromDirect: number;
  
  startTime?: Date;
  endTime?: Date;
}

/**
 * Result of a single online check-in session
 */
export interface OnlineCheckInResult {
  success: boolean;
  reservationNumber: string;
  duration: number;
  error?: string;
  digitalKeyDelivered: boolean;
}